"use client";
import { useState } from "react";
import { setScope } from "./actions";
import { Switch } from "@/components/ui/shadcn/switch";

interface Props {
  scope: string;
  userId: string;
  checked: boolean;
  disabled: boolean;
  onChange: (checked: boolean) => void;
}

const PermissionSwitch = (props: Props) => {
  const [checked, setChecked] = useState(props.checked);

  const handleChange = async (newChecked: boolean) => {
    props.onChange(newChecked);
    setChecked(newChecked);

    try {
      const result = await setScope(props.userId, props.scope, newChecked);
      if (!result.success) {
        setChecked(!newChecked);
      }
    } catch {
      setChecked(!newChecked);
    }
  };

  return (
    <Switch
      disabled={props.disabled}
      checked={checked}
      onCheckedChange={handleChange}
    />
  );
};

export default PermissionSwitch;
